
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import baseForm from '../FormComponents/baseFormComponent.vue'
import { required, numeric } from 'vuelidate/lib/validators'
import { Validations } from 'vuelidate-property-decorators'

@Component({
    components: {
        baseForm,
    }
})
export default class MilestoneComponent extends Vue {
    @Validations()
    validations = {
        milestone: {
            name: {required},
            code: {required},
            start: {required},
            // end: {required},
            startDepth: {required, numeric},
            endDepth: {required, numeric},
        }
    }
    
    @Prop()
    activities !:Array<any>
    @Prop()
    activity !:any

    @Prop()
    projectName !:string

    options: Array<any> = [
        { item: 'End Date', name: 'End Date' },
        { item: 'Duration', name: 'Duration' }
    ]

    dailyOperationFields:Array<any> = [
        {
            key:"dayIndex",
            label:"S/N"
        },
        {
            key:"date",
            label:"Date"
        },
        {
            key:"depth",
            label:"Depth (ft)"
        },
        {
            key:"description",
            label:"Description"
        },
        {
            key:"delete",
            label:""
        }
    ]

    dailyDurationOperationFields:Array<any> = [
        {
            key:"dayIndex",
            label:"S/N"
        },
        {
            key:"days",
            label:"Days"
        },
        {
            key:"depth",
            label:"Depth (ft)"
        },
        {
            key:"description",
            label:"Description"
        },
        {
            key:"delete",
            label:""
        }
    ]

    milestone: any = {
        id:'',
        name: '',
        code:'',
        description: '',
        start: null,
        end: null,
        startDepth: 0,
        endDepth: 0,
        duration: 0,
        selectedOption: 'Duration',
        parentActivityId:"",
        dailyOperations:[]
    }

    searchValue: string = ''
    activityId : any = ''
    isUpdate:boolean = false
    activeView:number = 1
    formErrors: string[] = []
    isDurationExceeded = false

    get compareAllDepths() {
        let result = false
        this.milestone.dailyOperations.forEach((operations: any) => {
            if (operations.depth <= parseInt(this.milestone.endDepth)) {
                result = false
            } else {
                result = true
            }
        });
        return result
    }

    search(e: any) {
        this.searchValue = e;
    }

    checkErrors() {
        this.formErrors = []

        if(this.milestone.name.length < 1) {
            this.formErrors.push('Milestone Name is Required')
        }
        if(this.milestone.code.length < 1) {
            this.formErrors.push('Milestone Code is Required')
        }
        // if(!this.milestone.start) {
        //     this.formErrors.push('Milestone Start Date is Required')
        // }
        // if(!this.milestone.end) {
        //     this.formErrors.push('Milestone End Date is Required')
        // }
        // if(parseInt(this.milestone.startDepth) > parseInt(this.milestone.endDepth) && this.activeView != 1) {
        //     this.formErrors.push('Start Depth Can\'t be greater the end depth')
        // }
        // if (this.compareAllDepths && this.activeView !== 1) {
        //     this.formErrors.push('No operation depth should be more than Milestone end depth')
        // }
    }

    gotoPrevious(){
        if(this.activeView>1){
            this.checkErrors()
            this.activeView--
        }
    }

    gotoNext(){
        if(this.activeView<2){
            this.activeView++
        }else{
            if(!this.isUpdate){
                this.addMilestone()   
            }else{
                this.updateMilestone()
            }
        }
    }

    get presentActivity () {
        return this.$store.getters['ActivityModule/getActiveActivity']
    }

    get activitiesOptions () {
        return this.activities.map((data: any) => {
            return {
                value: data.id,
                text: data.wellActivity.name
            }
        })
    }
    
    get isButtonDisabled(): boolean {
        if(this.formErrors.length > 0) {
            return true
        } else {
            return false
        }
    }

    get milestones () {
        return this.$store.getters['MilestoneModule/filteredMilestoneForActivity'](this.searchValue)
    }

    get startDatePickerMin(){
        if(this.presentActivity){
            return this.presentActivity.start
        }else{
            return this.activity ? this.activity.start : new Date()
        }
    }

    get datePickerMax(){
        if(this.presentActivity){
            return this.presentActivity.end
        }else{
            return this.activity ? this.activity.end : new Date()
        }
    }

    get endDatePickerMin(){
        if(this.presentActivity){
            return this.presentActivity.start
        }else{
            return this.activity ? this.activity.start : new Date()
        }
    }

    computeDuration(startDate:string,endDate:string){
        if(startDate==""||endDate=="")return 0
        const start = new Date(startDate);
        const end = new Date(endDate);

        // Calculate the difference in time (milliseconds)
        const diffTime = end.getTime() - start.getTime();

        // Convert the difference from milliseconds to days
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays;
    }

    @Watch("milestone.start")
    onStartDateChanged(){
        if(this.milestone.selectedOption !== 'End Date') return;
        let numberOfDays = this.computeDuration(this.milestone.start,this.milestone.end)
        if(numberOfDays>0){
            let newData = []
            for(let i=0;i<numberOfDays;i++){
                let thisDate = new Date(this.milestone.start)                
                thisDate.setDate(thisDate.getDate()+i)
                let thisDateString = (thisDate.getMonth() + 1) + "-" + thisDate.getDate() + "-" + thisDate.getFullYear();
                let existingDateIndex = this.milestone.dailyOperations.findIndex((thisOp:any) => thisOp.dayIndex == i)
                if(existingDateIndex>-1){
                    newData.push({
                        dayIndex :i,
                        days:this.milestone.dailyOperations[existingDateIndex].days,
                        date:thisDateString,
                        depth:this.milestone.dailyOperations[existingDateIndex].depth,
                        description:this.milestone.dailyOperations[existingDateIndex].description,
                    })
                }else{
                    newData.push({
                        dayIndex :i,
                        days:0,
                        date:thisDateString,
                        depth:0,
                        description: ''
                    })
                }
            }
            this.milestone.dailyOperations = newData
        }else{
            this.milestone.dailyOperations = []
        }
    }

    endDateChanged(){
        let numberOfDays = this.computeDuration(this.milestone.start,this.milestone.end)
        if(numberOfDays>0){
            let newData = []
            for(let i=0;i<numberOfDays;i++){
                let thisDate = new Date(this.milestone.start)
                thisDate.setDate(thisDate.getDate()+i)
                let thisDateString = (thisDate.getMonth() + 1) + "-" + thisDate.getDate() + "-" + thisDate.getFullYear();
                let existingDateIndex = this.milestone.dailyOperations.findIndex((thisOp:any) => thisOp.dayIndex == i)
                
                if(existingDateIndex>-1){
                    newData.push({
                        dayIndex :i,
                        days:this.milestone.dailyOperations[existingDateIndex].days,
                        date:thisDateString,
                        depth:this.milestone.dailyOperations[existingDateIndex].depth,
                        description:this.milestone.dailyOperations[existingDateIndex].description,
                    })
                }else{
                    newData.push({
                        dayIndex :i,
                        days:0,
                        date:thisDateString,
                        depth:this.milestone.startDepth,
                        description:''
                    })
                }
            }
            this.$set(this.milestone, 'dailyOperations', newData);
        }else{
            this.$set(this.milestone, 'dailyOperations', []);
        }
    }

    @Watch("milestone.end")
    onEndDateChanged(){
        if(this.milestone.selectedOption !== 'End Date') return;
        this.endDateChanged();
    }

    @Watch("milestone.selectedOption")
    onSelectedOptionChanged(){
        if(this.milestone.selectedOption === 'End Date') {
            this.endDateChanged();
        }
        else {
            const indexToDelete: Array<any> = [];
            this.milestone.dailyOperations.forEach((operation: any) => {
                if ((!operation.days || operation.days === 0) || (!operation.depth || operation.depth === 0)) {
                    indexToDelete.push(operation.dayIndex)
                }
            });
            indexToDelete.forEach(dayIndex => {
                const index = this.milestone.dailyOperations.findIndex((operation: any) => Number(operation.dayIndex) === Number(dayIndex));
                if (index !== -1) {
                    this.milestone.dailyOperations.splice(index, 1);
                }
            });
        }
    }
    
    durationChanged(){
        if (this.milestone.dailyOperations.length > 0) return;
        let newData = []
        newData.push({
            dayIndex :0,
            days:0,
            depth:this.milestone.startDepth,
            description:''
        })
        this.$set(this.milestone, 'dailyOperations', newData);
    }

    addDays(date: string, daysToAdd: any, fractionalDays?: number): string {
        let result: Date;

        if (typeof date === "string") {
            const [year, month, day] = date.split('-').map(Number);
            result = new Date(Date.UTC(year, month - 1, day));
        } else {
            result = new Date(date);
        }

        if (daysToAdd === "") return result.toISOString().split('T')[0];
        result.setUTCDate(result.getUTCDate() + Number.parseInt(daysToAdd));

        if (fractionalDays) {
            const fractionalHours = fractionalDays * 24;
            result.setUTCHours(result.getUTCHours() + fractionalHours);
        }
        
        if (isNaN(result.getTime())) {
            return '';
        }

        return result.toISOString().split('T')[0];
    }

    isFraction(num: number) {
        return num !== Math.floor(num);
    }
    

    addNewOperationRow() {
        let totalDays = 0;
        this.milestone.dailyOperations.forEach((operation: any) => {
            totalDays += Number(operation.days);
        });

        if (totalDays >= this.milestone.duration) return;

        const lastOperation = this.milestone.dailyOperations[this.milestone.dailyOperations.length - 1];
        
        if (lastOperation && 
            (lastOperation.days === 0 || lastOperation.days === undefined) && 
            lastOperation.depth === (this.milestone.startDepth || lastOperation.depth === undefined) && 
            lastOperation.description === '') {
            return;
        }

        const newRow = {
            dayIndex: this.milestone.dailyOperations.length,
            days: 0,
            depth: this.milestone.startDepth,
            description: ''
        }
        this.milestone.dailyOperations.push(newRow);
    }
    
    ondurationChanged(){
        if (this.milestones.length > 0) {
            const lastMilestone = this.milestones[this.milestones.length - 1];
            const isFraction = this.isFraction(Number(lastMilestone.duration))
            if (isFraction && this.milestone.start === lastMilestone.end) {
                const integerDays = Math.floor(Number(lastMilestone.duration));
                const fractionalDays = lastMilestone.duration - integerDays;
                let newEndDate:any = this.addDays(this.milestone.start,this.milestone.duration, fractionalDays)
                this.milestone.end = newEndDate;
            }
            else {
                let newEndDate:any = this.addDays(this.milestone.start,this.milestone.duration)
                this.milestone.end = newEndDate;
            }
        }
        else {
            const isFraction = this.isFraction(Number(this.milestone.duration))
            if (isFraction) {
                const integerDays = Math.floor(Number(this.milestone.duration));
                const fractionalDays = this.milestone.duration - integerDays;
                let newEndDate:any = this.addDays(this.milestone.start,this.milestone.duration, fractionalDays)
                this.milestone.end = newEndDate;
            }
            else {
                let newEndDate:any = this.addDays(this.milestone.start,this.milestone.duration)
                this.milestone.end = newEndDate;
            }
        }
        this.durationChanged();
        this.updateMilestoneDuration();
    }

    updateMilestoneDuration() {
        let totalDays = 0;
        this.milestone.dailyOperations.forEach((operation: any) => {
            totalDays += Number(operation.days);
        });

        if (totalDays > this.milestone.duration) {
            this.isDurationExceeded = true;
        }
        else {
            this.isDurationExceeded = false;
        }      
    }

    deleteOperation(dayIndex: any) {
        const index = this.milestone.dailyOperations.findIndex((operation: any) => Number(operation.dayIndex) === Number(dayIndex));
        if (index !== -1) {
            this.milestone.dailyOperations.splice(index, 1);

            this.milestone.dailyOperations.forEach((operation: any, i: number) => {
                operation.dayIndex = i;
            });
        }
    }

    reInitMilestone(){
        if (this.milestones.length > 0) {
            const lastMilestone = this.milestones[this.milestones.length - 1];
            this.milestone.start = lastMilestone.end;
        } else {
            this.milestone.start = null;
        }
        this.milestone.id = ''
        this.milestone.name = ''
        this.milestone.description = ''
        this.milestone.end = null
        this.milestone.selectedOption = 'Duration'
        this.milestone.duration = 0
        this.milestone.parentActivityId = ""
        this.milestone.code = ""
        this.milestone.dailyOperations = []
        this.activeView = 1
        this.$v.$reset()
    }

    addMilestone () {
        let milestoneToAdd = {
            name: this.milestone.name,
            start: this.milestone.start,
            end: this.milestone.end,
            startDepth:this.milestone.startDepth,
            endDepth:this.milestone.endDepth,
            selectedOption:this.milestone.selectedOption,
            duration:this.milestone.duration,
            code:this.milestone.code,
            dailyOperations:this.milestone.dailyOperations,
            description: this.milestone.description,
            parentActivityId:this.presentActivity ? this.presentActivity.id : this.activity.Id
        }
        
        this.$store.commit('MilestoneModule/addMilestoneToActivity',milestoneToAdd)
        this.reInitMilestone()
    }

    updateMilestone(){
        let milestoneToUpdate = {
            id:this.milestone.id,
            name: this.milestone.name,
            start: this.milestone.start,
            end: this.milestone.end,
            startDepth:this.milestone.startDepth,
            endDepth:this.milestone.endDepth,
            selectedOption:this.milestone.selectedOption,
            duration:this.milestone.duration,
            code:this.milestone.code,
            dailyOperations:this.milestone.dailyOperations,
            description: this.milestone.description,
            parentActivityId:this.presentActivity ? this.presentActivity.id : this.activity.Id
        }
        this.$store.commit('MilestoneModule/updateMilestone',milestoneToUpdate)
        this.reInitMilestone();
        this.isUpdate = false
    }

    editItemClicked(data:any){
        this.milestone.dailyOperations = data.dailyOperations?data.dailyOperations:[]
        this.milestone.id = data.id
        this.milestone.name = data.name
        this.milestone.start = data.start,
        this.milestone.end = data.end,
        this.milestone.selectedOption = data.selectedOption !== '' && data.selectedOption !== null ? data.selectedOption : 'Duration',
        this.milestone.duration = data.duration,
        this.milestone.description = data.description
        this.milestone.parentActivityId = this.presentActivity ? this.presentActivity.id : this.activity.Id
        this.milestone.code = data.code
        this.milestone.startDepth = data.startDepth
        this.milestone.endDepth = data.endDepth
        this.isUpdate = true
        this.checkErrors()
    }

    cancel () {
        this.milestone.id = ''
        this.milestone.name = ''
        this.milestone.start = null,
        this.milestone.end = null,
        this.milestone.selectedOption = 'Duration',
        this.milestone.duration = 0,
        this.milestone.description = ''
        this.milestone.parentActivityId = ''
        this.isUpdate = !this.isUpdate
    }

    deleteItemClicked(data:any){
        this.$store.commit('MilestoneModule/deleteMilestone', data)
        this.reInitMilestone()
    }

    onSelectedActivityChanged(data:any) {
         this.$store.commit("MilestoneModule/setActivityId", this.activityId)
         if(this.milestones.length<1)this.$store.dispatch("MilestoneModule/getMilestonesForActivity")
    }
    
    mounted() {
        this.activityId = this.presentActivity ? this.presentActivity.id : this.activity.Id
        this.reInitMilestone();
        this.checkErrors()
    }
}
